(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9361],{

/***/ 61129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{"use strict";var e={n:t=>{var n=t&&t.__esModule?()=>t.default:()=>t;return e.d(n,{a:n}),n},d:(t,n)=>{for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};e.r(t),e.d(t,{default:()=>Le});const n=__webpack_require__(45697);var o=e.n(n);const r=__webpack_require__(67294);var i=e.n(r),s="fslightbox-",c="".concat(s,"styles"),a="".concat(s,"cursor-grabbing"),l="".concat(s,"full-dimension"),u="".concat(s,"flex-centered"),f="".concat(s,"transform-transition"),d="".concat(s,"absoluted"),p="".concat(s,"fade-in"),m="".concat(s,"fade-out"),h=p+"-strong",g=m+"-strong",v="".concat(s,"opacity-1");"".concat(s,"source");const b=function(e){var t=e.size,n=e.viewBox,o=e.d;return i().createElement("svg",{width:t,height:t,viewBox:n,xmlns:"http://www.w3.org/2000/svg"},i().createElement("path",{className:"".concat(s,"svg-path"),d:o}))},x=function(e){var t=e.onClick,n=e.viewBox,o=e.size,r=e.d,c=e.title;return i().createElement("div",{onClick:t,className:"".concat(s,"toolbar-button ").concat(u),title:c},i().createElement(b,{viewBox:n,size:o,d:r}))};function y(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}function w(e){var t=e.o,n=t.fs,o=n.o,s=n.x,c=t.fss,a=function(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var o,r,i,s,c=[],a=!0,l=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;a=!1}else for(;!(a=(o=i.call(n)).done)&&(c.push(o.value),c.length!==t);a=!0);}catch(e){l=!0,r=e}finally{try{if(!a&&null!=n.return&&(s=n.return(),Object(s)!==s))return}finally{if(l)throw r}}return c}}(e,t)||function(e,t){if(e){if("string"==typeof e)return y(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?y(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}((0,r.useState)(!1),2),l=a[0],u=a[1];return c.g=function(){return l},c.s=u,i().createElement(x,{onClick:l?s:o,viewBox:l?"0 0 950 1024":"0 0 18 18",size:l?"24px":"20px",d:l?"M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z":"M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z",title:l?"Exit fullscreen":"Enter fullscreen"})}const S=function(e){var t=e.fsLightbox.core.lightboxCloser.closeLightbox;return i().createElement(x,{onClick:t,viewBox:"0 0 24 24",size:"20px",d:"M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z",title:"Close"})},E=function(e){var t=e.fsLightbox;return i().createElement("div",{className:"".concat(s,"toolbar")},i().createElement(w,{o:t}),i().createElement(S,{fsLightbox:t}))};function L(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}const A=function(e){var t,n,o=e.fsLightbox,c=o.componentsServices,a=o.props.sources,l=o.stageIndexes,u=(t=(0,r.useState)(l.current+1),n=2,function(e){if(Array.isArray(e))return e}(t)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var o,r,i,s,c=[],a=!0,l=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;a=!1}else for(;!(a=(o=i.call(n)).done)&&(c.push(o.value),c.length!==t);a=!0);}catch(e){l=!0,r=e}finally{try{if(!a&&null!=n.return&&(s=n.return(),Object(s)!==s))return}finally{if(l)throw r}}return c}}(t,n)||function(e,t){if(e){if("string"==typeof e)return L(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?L(e,t):void 0}}(t,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()),f=u[0],d=u[1];c.setSlideNumber=function(e){d(e)};var p=i().createRef(),m=i().createRef();return(0,r.useEffect)((function(){m.current.offsetWidth>55&&(p.current.style.justifyContent="flex-start")}),[]),i().createElement("div",{ref:p,className:"".concat(s,"slide-number-container")},i().createElement("div",{ref:m,className:"fslightbox-flex-centered"},i().createElement("span",null,f),i().createElement("span",{className:"".concat(s,"slash")}),i().createElement("span",null,a.length)))},O=function(e){var t=e.fsLightbox;return i().createElement("div",{className:"".concat(s,"nav")},i().createElement(E,{fsLightbox:t}),t.props.sources.length>1&&i().createElement(A,{fsLightbox:t}))};function C(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}const I=function(e){var t,n,o=e.fsLightbox.componentsServices,c=(t=(0,r.useState)(!1),n=2,function(e){if(Array.isArray(e))return e}(t)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var o,r,i,s,c=[],a=!0,l=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;a=!1}else for(;!(a=(o=i.call(n)).done)&&(c.push(o.value),c.length!==t);a=!0);}catch(e){l=!0,r=e}finally{try{if(!a&&null!=n.return&&(s=n.return(),Object(s)!==s))return}finally{if(l)throw r}}return c}}(t,n)||function(e,t){if(e){if("string"==typeof e)return C(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?C(e,t):void 0}}(t,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()),a=c[0],u=c[1];return o.showSlideSwipingHovererIfNotYet=function(){a||u(!0)},o.hideSlideSwipingHovererIfShown=function(){a&&u(!1)},a&&i().createElement("div",{className:"".concat(s,"slide-swiping-hoverer ").concat(l," ").concat(d)})},j=function(e){var t=e.onClick,n=e.name,o=e.d,r=n.charAt(0).toUpperCase()+n.slice(1),c="".concat(s,"slide-btn");return i().createElement("div",{onClick:t,title:"".concat(r," slide"),className:"".concat(c,"-container ").concat(c,"-").concat(n,"-container")},i().createElement("div",{className:"".concat(c," ").concat(u)},i().createElement(b,{viewBox:"0 0 20 20",size:"20px",d:o})))};function z(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}function F(e){var t=e.o,n=t.elements.sourcesComponents,o=t.isl,s=t.loc,c=t.saw,a=t.sawu,l=t.st,u=t.stageIndexes.current,f=e.i,d=function(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var o,r,i,s,c=[],a=!0,l=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;a=!1}else for(;!(a=(o=i.call(n)).done)&&(c.push(o.value),c.length!==t);a=!0);}catch(e){l=!0,r=e}finally{try{if(!a&&null!=n.return&&(s=n.return(),Object(s)!==s))return}finally{if(l)throw r}}return c}}(e,t)||function(e,t){if(e){if("string"==typeof e)return z(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?z(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}((0,r.useState)(!1),2),p=d[0],m=d[1];return a[f]=function(){m(!p)},i().createElement("div",{ref:c[f]},!o[f]&&i().createElement("div",{className:"fslightboxl"},i().createElement("div",null),i().createElement("div",null),i().createElement("div",null),i().createElement("div",null)),(f===u||!s&&l.i(f))&&n[f])}function k(e){var t=e.o,n=e.i,o=t.props.slideDistance,r=t.smw,s=t.smwm,c=t.st,a=0;s[n]={};var p=s[n];function m(){return r[n].current}function h(e){m().style.transform="translateX(".concat(e+a,"px)"),a=0}function g(){return(1+o)*innerWidth}return p.s=function(){m().style.display="flex"},p.h=function(){m().style.display="none"},p.a=function(){m().classList.add(f)},p.d=function(){m().classList.remove(f)},p.n=function(){m().style.removeProperty("transform")},p.v=function(e){return a=e,p},p.ne=function(){h(-g())},p.z=function(){h(0)},p.p=function(){h(g())},i().createElement("div",{ref:r[n],className:"".concat(d," ").concat(l," ").concat(u),style:c.i(n)?{}:{display:"none"}},i().createElement(F,{o:t,i:n}))}function T(e){return e.touches?e.touches[0].screenX:e.screenX}const R=function(e){for(var t=e.o,n=[],o=0;o<t.sl;o++)n.push(i().createElement(k,{o:t,i:o,key:o}));return i().createElement("div",{className:"".concat(d," ").concat(l),onPointerDown:function(e){!function(e,t){var n=e.elements.sources,o=e.p,r=e.smwm,i=e.stageIndexes;"IMG"===t.target.tagName&&t.preventDefault(),o.isSwiping=!0,o.downScreenX=T(t),o.swipedX=0;var s=n[i.current].current;s&&s.contains(t.target)?o.isSourceDownEventTarget=!0:o.isSourceDownEventTarget=!1;for(var c=0;c<r.length;c++)r[c].d()}(t,e)}},n)};var H=".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .25s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .25s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .25s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .25s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;touch-action:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px!important;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-previous-container{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-previous-container{padding-left:3px}}.fslightbox-slide-btn-next-container{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-next-container{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-next-container{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-next-container{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightboxin{font-size:22px;color:#eaebeb;margin:auto}.fslightboxv{object-fit:cover}.fslightboxl{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightboxl div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightboxl 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightboxl div:nth-child(1){animation-delay:-.45s}.fslightboxl div:nth-child(2){animation-delay:-.3s}.fslightboxl div:nth-child(3){animation-delay:-.15s}@keyframes fslightboxl{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightboxs{position:relative;z-index:2;opacity:0;transform:translateZ(0);margin:auto;backface-visibility:hidden}";function N(){var e=document.createElement("style");e.className=c,e.appendChild(document.createTextNode(H)),document.head.appendChild(e)}function M(e){for(var t=e.props.sources,n=[],o=0;o<t.length;o++)n.push(i().createRef());return n}function U(e,t,n){for(var o=0;o<e.props.sources.length;o++)e.collections[t][o]=e.resolve(n,[o])}var P="fslightbox-types";function W(e){var t,n=e.props,o=!1,r={},i=0;if(this.getSourceTypeFromLocalStorageByUrl=function(e){return t[e]?t[e]:s(e)},this.handleReceivedSourceTypeForUrl=function(e,n){if(r[n]===o&&(i--,"invalid"!==e?r[n]=e:delete r[n],0===i)){!function(e,t){for(var n in t)e[n]=t[n]}(t,r);try{localStorage.setItem(P,JSON.stringify(t))}catch(e){}}},n.disableLocalStorage)this.getSourceTypeFromLocalStorageByUrl=function(){},this.handleReceivedSourceTypeForUrl=function(){};else{try{t=JSON.parse(localStorage.getItem(P))}catch(e){}t||(t={},this.getSourceTypeFromLocalStorageByUrl=s)}function s(e){i++,r[e]=o}}var B="image",D="video",X="youtube",q="custom",V="invalid";function _(){return _=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},_.apply(this,arguments)}function Y(e){var t=e.o,n=t.collections.sourceLoadHandlers,o=t.elements.sources,r=t.props,s=r.customAttributes,c=r.sources,a=e.i;return i().createElement("img",_({className:"fslightboxs",onLoad:n[a].handleImageLoad,ref:o[a],src:c[a]},s&&s[a]?s[a]:{}))}function $(){return $=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},$.apply(this,arguments)}function Q(e){var t=e.o,n=t.collections.sourceLoadHandlers,o=t.elements.sources,r=t.props,s=r.customAttributes,c=r.sources,a=t.timeout,l=e.i;return a(n[l].handleNotMetaDatedVideoLoad,3e3),i().createElement("video",$({ref:o[l],className:"fslightboxs fslightboxv",src:c[l],onLoadedMetadata:n[l].handleVideoLoad,controls:!0},s&&s[l]?s[l]:{}))}function G(){return G=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},G.apply(this,arguments)}function J(e){var t=e.o,n=t.elements.sources,o=t.collections.sourceLoadHandlers,s=t.props,c=s.customAttributes,a=s.sources,l=e.i;(0,r.useEffect)(o[l].handleYoutubeLoad);var u=a[l],f=u.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2],d=u.split("?")[1];return d=d||"",i().createElement("iframe",G({ref:n[l],className:"fslightboxs",src:"https://www.youtube.com/embed/".concat(f,"?").concat(d),frameBorder:"0",allowFullScreen:!0},c&&c[l]?c[l]:{}))}function Z(e){var t=e.o,n=t.isl,o=t.sawu,s=t.smw,c=e.i;return(0,r.useEffect)((function(){n[c]=!0,o[c](),s[c].current.classList.add(h)})),i().createElement("div",{className:"fslightboxin ".concat(u)},"Invalid source")}function K(e){var t=e.o,n=t.collections.sourceLoadHandlers,o=t.elements.sources,s=t.props.sources,c=e.i;(0,r.useEffect)(n[c].handleCustomLoad);var a=s[c].props.className;return i().cloneElement(s[c],{ref:o[c],className:a?"".concat(a," fslightboxs"):"fslightboxs"})}function ee(e){var t=e.componentsServices.isLightboxOpenManager,n=e.elements.sourcesComponents,o=e.sawu;this.runActionsForSourceTypeAndIndex=function(r,s){var c;switch(r){case B:c=Y;break;case D:c=Q;break;case X:c=J;break;case q:c=K;break;default:c=Z}n[s]=i().createElement(c,{o:e,i:s}),t.get()&&o[s]()}}function te(e,t,n){var o=e.props,r=o.types,i=o.type,s=o.sources;this.getTypeSetByClientForIndex=function(e){var t;return r&&r[e]?t=r[e]:i&&(t=i),t},this.retrieveTypeWithXhrForIndex=function(e){!function(e,t){var n=document.createElement("a");n.href=e;var o=n.hostname;if("www.youtube.com"===o||"youtu.be"===o)return t(X);var r=new XMLHttpRequest;r.onreadystatechange=function(){if(4!==r.readyState){if(2===r.readyState){var e,n=r.getResponseHeader("content-type");switch(n.slice(0,n.indexOf("/"))){case"image":e=B;break;case"video":e=D;break;default:e=V}r.onreadystatechange=null,r.abort(),t(e)}}else t(V)},r.open("GET",e),r.send()}(s[e],(function(o){t.handleReceivedSourceTypeForUrl(o,s[e]),n.runActionsForSourceTypeAndIndex(o,e)}))}}function ne(e){var t=e.componentsServices.isLightboxOpenManager,n=e.core,o=n.lightboxCloser,r=n.slideIndexChanger,i=e.stageIndexes;this.runTogglerUpdateActions=function(){t.get()?o.closeLightbox():e.ii?e.o():e.i()},this.runCurrentStageIndexUpdateActionsFor=function(e){e!==i.current&&(t.get()?r.jumpTo(e):i.current=e)}}function oe(e){var t=e.core.lightboxUpdater,n=(0,e.resolve)(ne);t.handleUpdate=function(t){var o=e.props;void 0!==o.source?n.runCurrentStageIndexUpdateActionsFor(o.sources.indexOf(o.source)):void 0!==o.sourceIndex?n.runCurrentStageIndexUpdateActionsFor(o.sourceIndex):void 0!==o.slide&&n.runCurrentStageIndexUpdateActionsFor(o.slide-1),t.toggler!==o.toggler&&n.runTogglerUpdateActions()}}var re=250;function ie(e){var t=e.loc,n=e.stageIndexes,o=e.sawu;if(t)o[n.current]();else for(var r in n){var i=n[r];void 0!==i&&o[i]()}}function se(e,t){var n=e.current.classList;n.contains(t)&&n.remove(t)}function ce(e){var t,n=e.dss,o=e.p,r=e.sl,i=(t=!1,function(){return!t&&(t=!0,requestAnimationFrame((function(){t=!1})),!0)});this.a=1===r||n?function(){o.swipedX=1}:function(t){o.isSwiping&&i()&&function(e,t){var n=e.componentsServices,o=e.elements.container,r=e.p,i=e.smwm,s=e.stageIndexes;n.showSlideSwipingHovererIfNotYet(),o.current.classList.add(a),r.swipedX=T(t)-r.downScreenX;var c=s.previous,l=s.next;function u(e,t){i[e].v(r.swipedX)[t]()}u(s.current,"z"),void 0!==c&&r.swipedX>0?u(c,"ne"):void 0!==l&&r.swipedX<0&&u(l,"p")}(e,t)}}function ae(e){var t=e.core.slideIndexChanger,n=e.smwm,o=e.stageIndexes,r=e.sws;function i(e){var t=n[o.current];t.a(),t[e]()}function s(e,t){void 0!==e&&(n[e].s(),n[e][t]())}this.p=function(){var e=o.previous;if(void 0===e)i("z");else{i("p");var n=o.next;t.changeTo(e);var c=o.previous;r.d(c),r.b(n),i("z"),s(c,"ne")}},this.n=function(){var e=o.next;if(void 0===e)i("z");else{i("ne");var n=o.previous;t.changeTo(e);var c=o.next;r.d(c),r.b(n),i("z"),s(c,"p")}}}function le(e){var t=e.componentsServices,n=e.core.lightboxCloser,o=e.dss,r=e.elements.container,i=e.p,s=e.props.disableBackgroundClose,c=(0,e.r)(ae);this.n=function(){t.hideSlideSwipingHovererIfShown(),i.isSourceDownEventTarget||s||n.closeLightbox(),i.isSwiping=!1},this.s=function(){o||(i.swipedX>0?c.p():c.n()),t.hideSlideSwipingHovererIfShown(),r.current.classList.remove(a),i.isSwiping=!1}}function ue(e){var t,n,o;!function(e){var t=e.props.sources,n=e.st,o=e.stageIndexes,r=t.length-1;n.p=function(){return 0===o.current?r:o.current-1},n.n=function(){return o.current===r?0:o.current+1},n.u=0===r?function(){}:1===r?function(){0===o.current?(o.next=1,delete o.previous):(o.previous=0,delete o.next)}:function(){o.previous=n.p(),o.next=n.n()},n.i=r<=2?function(){return!0}:function(e){var t=o.current;if(0===t&&e===r||t===r&&0===e)return!0;var n=t-e;return-1===n||0===n||1===n}}(e),n=(t=e).core.classFacade,o=t.elements,n.removeFromEachElementClassIfContains=function(e,t){for(var n=0;n<o[e].length;n++)se(o[e][n],t)},function(e){var t=e.fs,n=e.fss,o=["fullscreenchange","webkitfullscreenchange","mozfullscreenchange","MSFullscreenChange"];function r(e){for(var t=0;t<o.length;t++)document[e](o[t],i)}function i(){n.s(document.fullscreenElement||document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement)}t.o=function(){n.s(!0);var e=document.documentElement;e.requestFullscreen?e.requestFullscreen():e.mozRequestFullScreen?e.mozRequestFullScreen():e.webkitRequestFullscreen?e.webkitRequestFullscreen():e.msRequestFullscreen&&e.msRequestFullscreen()},t.x=function(){n.s(!1),document.exitFullscreen?document.exitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen?document.webkitExitFullscreen():document.msExitFullscreen&&document.msExitFullscreen()},t.t=function(){n.g()?t.x():t.o()},t.l=function(){r("addEventListener")},t.q=function(){r("removeEventListener")}}(e),function(e){var t,n,o=e.core,r=o.globalEventsController,i=o.windowResizeActioner,s=e.fs,c=(0,e.r)(ce);r.attachListeners=function(){document.addEventListener("pointermove",c.a),n=function(t){var n,o,r;o=(n=e).p,r=(0,n.r)(le),o.isSwiping&&(o.swipedX?r.s():r.n())},document.addEventListener("pointerup",n),addEventListener("resize",i.runActions),t=function(t){!function(e,t){var n=e.core.lightboxCloser,o=e.fs;switch(t.key){case"Escape":n.closeLightbox();break;case"ArrowLeft":e.pr();break;case"ArrowRight":e.n();break;case"F11":t.preventDefault(),o.t()}}(e,t)},document.addEventListener("keydown",t),s.l()},r.removeListeners=function(){document.removeEventListener("pointermove",c.a),document.removeEventListener("pointerup",n),removeEventListener("resize",i.runActions),document.removeEventListener("keydown",t),s.q()}}(e),function(e){var t=e.core,n=t.lightboxCloser,o=t.lightboxCloseActioner;n.closeLightbox=function(){o.isLightboxFadingOut||o.runActions()}}(e),function(e){var t=e.componentsServices.isLightboxOpenManager,n=e.core,o=n.globalEventsController,r=n.lightboxCloseActioner,i=n.scrollbarRecompensor,s=e.e,c=e.elements.container,a=e.fs,l=e.fss,u=e.p,f=e.props,d=e.timeout;r.isLightboxFadingOut=!1,r.runActions=function(){r.isLightboxFadingOut=!0,c.current.classList.add(g),o.removeListeners(),f.exitFullscreenOnClose&&l.g()&&a.x(),d((function(){r.isLightboxFadingOut=!1,u.isSwiping=!1,c.current.classList.remove(g),document.documentElement.classList.remove("fslightbox-open"),i.removeRecompense(),t.set(!1),s("onClose")}),re-30)}}(e),oe(e),function(e){var t=e.data,n=e.core.scrollbarRecompensor;n.addRecompense=function(){"complete"===document.readyState?o():window.addEventListener("load",(function(){o(),n.addRecompense=o}))};var o=function(){document.body.offsetHeight>window.innerHeight&&(document.body.style.marginRight=t.scrollbarWidth+"px")};n.removeRecompense=function(){document.body.style.removeProperty("margin-right")}}(e),function(e){var t=e.core.slideIndexChanger,n=e.sl,o=e.st;n>1?(e.pr=function(){t.jumpTo(o.p())},e.n=function(){t.jumpTo(o.n())}):(e.pr=function(){},e.n=function(){})}(e),function(e){var t=e.componentsServices,n=e.core.slideIndexChanger,o=e.isl,r=e.saw,i=e.smwm,s=e.st,c=e.stageIndexes,a=e.sws;n.changeTo=function(n){c.current=n,s.u(),t.setSlideNumber(n+1),ie(e)},n.jumpTo=function(e){var t=c.previous,l=c.current,u=c.next,f=o[l],d=o[e];n.changeTo(e);for(var h=0;h<i.length;h++)i[h].d();a.d(l),a.c(),requestAnimationFrame((function(){requestAnimationFrame((function(){var e=c.previous,n=c.current,h=c.next;function g(){s.i(l)?l===c.previous?i[l].ne():l===c.next&&i[l].p():(i[l].h(),i[l].n())}f&&r[l].current.classList.add(m),d&&r[n].current.classList.add(p),a.a(),void 0!==e&&e!==l&&i[e].ne(),i[n].n(),void 0!==h&&h!==l&&i[h].p(),a.b(t),a.b(u),o[l]?setTimeout(g,re-40):g()}))}))}}(e),function(e){var t=e.isl,n=e.stageIndexes,o=e.saw,r=e.smwm,i=e.st,s=e.sws;s.a=function(){for(var e in n)r[n[e]].s()},s.b=function(e){void 0===e||i.i(e)||(r[e].h(),r[e].n())},s.c=function(){for(var e in n)s.d(n[e])},s.d=function(e){if(t[e]){var n=o[e];se(n,h),se(n,p),se(n,m)}}}(e),function(e){var t=e.collections.sourceSizers,n=e.core.windowResizeActioner,o=e.data,r=e.elements.sources,i=e.smwm,s=e.stageIndexes;n.runActions=function(){innerWidth<992?o.maxSourceWidth=innerWidth:o.maxSourceWidth=.9*innerWidth,o.maxSourceHeight=.9*innerHeight;for(var e=0;e<r.length;e++)i[e].d(),t[e]&&r[e].current&&t[e].adjustSize();var n=s.previous,c=s.next;void 0!==n&&i[n].ne(),void 0!==c&&i[c].p()}}(e)}function fe(e,t,n,o){var r=e.data,i=e.elements.sources,s=n/o,c=0;this.adjustSize=function(){if((c=r.maxSourceWidth/s)<r.maxSourceHeight)return n<r.maxSourceWidth&&(c=o),a();c=o>r.maxSourceHeight?r.maxSourceHeight:o,a()};var a=function(){var e=i[t].current.style;e.width=c*s+"px",e.height=c+"px"}}function de(e,t){var n=this,o=e.collections.sourceSizers,r=e.elements.sources,i=e.isl,s=e.resolve,c=e.saw,a=e.sawu;function l(e,n){o[t]=s(fe,[t,e,n]),o[t].adjustSize()}this.runActions=function(e,o){i[t]=!0,a[t](),r[t].current.classList.add(v),c[t].current.classList.add(h),l(e,o),n.runActions=l}}function pe(e,t){var n,o=this,r=e.elements.sources,i=e.props,s=(0,e.resolve)(de,[t]);this.handleImageLoad=function(e){var t=e.target,n=t.naturalWidth,o=t.naturalHeight;s.runActions(n,o)},this.handleVideoLoad=function(e){var t=e.target,o=t.videoWidth,r=t.videoHeight;n=!0,s.runActions(o,r)},this.handleNotMetaDatedVideoLoad=function(){n||o.handleYoutubeLoad()},this.handleYoutubeLoad=function(){var e=1920,t=1080;i.maxYoutubeVideoDimensions&&(e=i.maxYoutubeVideoDimensions.width,t=i.maxYoutubeVideoDimensions.height),s.runActions(e,t)},this.handleCustomLoad=function(){var e=r[t].current;if(e){var n=e.offsetWidth,i=e.offsetHeight;n&&i?s.runActions(n,i):setTimeout(o.handleCustomLoad)}}}function me(e){return me="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},me(e)}function he(e){return he="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},he(e)}function ge(e,t,n){return ge=we()?Reflect.construct.bind():function(e,t,n){var o=[null];o.push.apply(o,t);var r=new(Function.bind.apply(e,o));return n&&xe(r,n.prototype),r},ge.apply(null,arguments)}function ve(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}function be(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,(void 0,r=function(e,t){if("object"!==he(e)||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,"string");if("object"!==he(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(o.key),"symbol"===he(r)?r:String(r)),o)}var r}function xe(e,t){return xe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},xe(e,t)}function ye(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function we(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}function Se(e){return Se=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Se(e)}"object"===("undefined"==typeof document?"undefined":me(document))&&N();var Ee=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&xe(e,t)}(u,e);var t,n,o,r,a=(o=u,r=we(),function(){var e,t=Se(o);if(r){var n=Se(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return function(e,t){if(t&&("object"===he(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return ye(e)}(this,e)});function u(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),(t=a.call(this,e)).state={isOpen:!1},t.data={maxSourceWidth:0,maxSourceHeight:0,scrollbarWidth:0},t.isl=[],t.p={isSwiping:!1,downScreenX:null,isSourceDownEventTarget:!1,swipedX:0},t.stageIndexes={current:0},t.componentsServices={showSlideSwipingHovererIfNotYet:null,hideSlideSwipingHovererIfShown:null,setSlideNumber:null,isSlideSwipingHovererShown:{},isLightboxOpenManager:{get:function(){return t.state.isOpen},set:function(e,n){t.setState({isOpen:e},n)}}},t.fss={},t.sawu=[],t.elements={container:i().createRef(),sources:null,sourcesComponents:[]},t.collections={sourceLoadHandlers:[],sourceSizers:[],xhrs:[]},t.smwm=[],t.core={classFacade:{},globalEventsController:{},lightboxCloser:{},lightboxCloseActioner:{},lightboxUpdater:{},scrollbarRecompensor:{},slideIndexChanger:{},windowResizeActioner:{}},t.fs={},t.st={},t.sws={},t.timeout=t.timeout.bind(ye(t)),t.getQueuedAction=t.getQueuedAction.bind(ye(t)),t.r=t.resolve.bind(ye(t)),t.resolve=t.resolve.bind(ye(t)),t.e=t.e.bind(ye(t)),oe(ye(t)),function(e){var t=e.componentsServices.isLightboxOpenManager,n=e.core,o=n.globalEventsController,r=n.scrollbarRecompensor,i=n.windowResizeActioner,s=e.e,c=e.elements,a=e.st,l=e.stageIndexes,u=e.sws;function f(){ie(e),document.documentElement.classList.add("fslightbox-open"),r.addRecompense(),o.attachListeners(),i.runActions(),s("onOpen")}e.o=function(){U(e,"sourceLoadHandlers",pe),t.set(!0,(function(){u.b(l.previous),u.b(l.current),u.b(l.next),a.u(),u.c(),u.a(),f(),s("onShow")}))},e.i=function(){e.ii=!0,function(e){var t=e.props;e.s=t.sources,e.sl=e.s.length,e.dss=t.disableSlideSwiping,e.loc=t.loadOnlyCurrentSource}(e),e.smw=M(e),e.saw=M(e),c.sources=M(e),U(e,"sourceLoadHandlers",pe),ue(e),a.u(),t.set(!0,(function(){f(),function(e){for(var t=e.props.sources,n=e.resolve,o=n(W),r=n(ee),i=n(te,[o,r]),s=0;s<t.length;s++)if("string"==typeof t[s]){var c=i.getTypeSetByClientForIndex(s);if(c)r.runActionsForSourceTypeAndIndex(c,s);else{var a=o.getSourceTypeFromLocalStorageByUrl(t[s]);a?r.runActionsForSourceTypeAndIndex(a,s):i.retrieveTypeWithXhrForIndex(s)}}else r.runActionsForSourceTypeAndIndex(q,s)}(e),s("onInit")}))}}(ye(t)),t}return t=u,n=[{key:"timeout",value:function(e,t){var n=this;setTimeout((function(){n.elements.container.current&&e()}),t)}},{key:"getQueuedAction",value:function(e,t){var n=this,o=[];return function(){o.push(!0),n.timeout((function(){o.pop(),o.length||e()}),t)}}},{key:"resolve",value:function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return n.unshift(this),ge(e,function(e){if(Array.isArray(e))return ve(e)}(t=n)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(t)||function(e,t){if(e){if("string"==typeof e)return ve(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?ve(e,t):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}())}},{key:"e",value:function(e){var t=this.props[e];t&&t(this)}},{key:"componentDidUpdate",value:function(e,t,n){this.core.lightboxUpdater.handleUpdate(e)}},{key:"componentDidMount",value:function(){var e,t,n,o;t=(e=this).data,n=e.i,o=e.props.openOnMount,document.getElementsByClassName(c).length||N(),t.scrollbarWidth=function(){var e=document.createElement("div"),t=e.style,n=document.createElement("div");t.visibility="hidden",t.width="100px",t.msOverflowStyle="scrollbar",t.overflow="scroll",n.style.width="100%",document.body.appendChild(e);var o=e.offsetWidth;e.appendChild(n);var r=n.offsetWidth;return document.body.removeChild(e),o-r}(),o&&n()}},{key:"componentWillUnmount",value:function(){!function(e){for(var t=e.collections.xhrs,n=e.componentsServices.isLightboxOpenManager,o=e.core.globalEventsController,r=0;r<t.length;r++)t[r].abort();n.get()&&o.removeListeners()}(this)}},{key:"render",value:function(){return this.state.isOpen?i().createElement("div",{ref:this.elements.container,className:"".concat(s,"container ").concat(l," ").concat(h)},i().createElement(I,{fsLightbox:this}),i().createElement(O,{fsLightbox:this}),this.props.sources.length>1?i().createElement(i().Fragment,null,i().createElement(j,{onClick:this.pr,name:"previous",d:"M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"}),i().createElement(j,{onClick:this.n,name:"next",d:"M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z"})):null,i().createElement(R,{o:this})):null}}],n&&be(t.prototype,n),Object.defineProperty(t,"prototype",{writable:!1}),u}(r.Component);Ee.propTypes={toggler:o().bool,sources:o().array,slide:o().number,source:o().string,sourceIndex:o().number,onOpen:o().func,onClose:o().func,onInit:o().func,onShow:o().func,disableLocalStorage:o().bool,types:o().array,type:o().string,customAttributes:o().array,maxYoutubeVideoDimensions:o().object,disableBackgroundClose:o().bool,disableSlideSwiping:o().bool,exitFullscreenOnClose:o().bool,loadOnlyCurrentSource:o().bool,openOnMount:o().bool,slideDistance:o().number},Ee.defaultProps={slideDistance:.3};const Le=Ee;module.exports=t})();

/***/ }),

/***/ 91319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroTitle = (param)=>{
    let { align , color , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroTitle.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_4__/* .textAlignPropTypes */ .g4,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroTitle);


/***/ }),

/***/ 69591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Hero_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Hero.js









const Hero = (param)=>{
    let { align ="center" , children , color ="black--02" , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , backgroundImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("section-hero", align && "section-hero-text-".concat(align), color && "section-hero-color-".concat(color), "".concat(backgroundImage ? "section-hero-custom-background" : ""), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        style: {
            ...backgroundImage && {
                backgroundImage: "url(".concat(backgroundImage, ")")
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
Hero.propTypes = {
    align: props_sx/* textAlignPropTypes */.g4,
    className: prop_types.string,
    children: prop_types.node.isRequired,
    color: (0,prop_types.oneOf)([
        "1",
        "1--light",
        "2",
        "3",
        "4",
        "5",
        "6",
        "white",
        "black--02",
        "transparent",
        "gradient"
    ]),
    backgroundImage: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js



/***/ }),

/***/ 15945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Line_Line; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/Line.js






const Line = (param)=>{
    let { className ="" , opacity ="" , isGradient =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("line", opacity && "line--opacity-".concat(opacity), isGradient && "line--gradient", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className)
    });
};
Line.propTypes = {
    className: prop_types.string,
    opacity: (0,prop_types.oneOf)([
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ]),
    isGradient: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Line_Line = (Line);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js



/***/ }),

/***/ 41848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const TableResponsiveWrapper = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table-responsive", className),
        children: children
    });
};
TableResponsiveWrapper.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (TableResponsiveWrapper);


/***/ }),

/***/ 72483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Tbody = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
        ...props,
        children: children
    });
};
Tbody.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Tbody);


/***/ }),

/***/ 182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18981);








const Td = (param)=>{
    let { className ="" , align , isBorderNone =false , isActive =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , verticalAlign , children , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__td", isActive && "table-active", align && "table__td--".concat(align), verticalAlign && "table__td-vertical-align--".concat(verticalAlign), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Td.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    align: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .textAlignPropTypes */ .g4,
    className: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_7__.node,
    verticalAlign: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "baseline",
        "top",
        "middle",
        "sub",
        "bottom",
        "text-top"
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Td);


/***/ }),

/***/ 11794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18981);








const Th = (param)=>{
    let { className ="" , isBorderNone =false , isActive =false , children , align ="" , verticalAlign , isUppercaseNone =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__th", isActive && "table-active", align && "table__th--".concat(align), verticalAlign && "table__th-vertical-align--".concat(verticalAlign), isUppercaseNone && "table__th--uppercase-none", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Th.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_7__.node,
    isUppercaseNone: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    align: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "left",
        "right",
        "center"
    ]),
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_5__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_3__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingPropTypes */ .Xj,
    verticalAlign: (0,prop_types__WEBPACK_IMPORTED_MODULE_7__.oneOf)([
        "baseline",
        "top",
        "middle",
        "sub",
        "bottom",
        "text-top"
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Th);


/***/ }),

/***/ 40662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const Thead = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
        ...props,
        children: children
    });
};
Thead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Thead);


/***/ }),

/***/ 455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18981);







const Tr = (param)=>{
    let { className ="" , isBorderNone =false , isActive =false , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .tF
    } , ...props } = param;
    const borderProp = isBorderNone ? {
        border: {
            width: 0
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("table__tr", isActive && "table-active", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* .deepMergeProps */ .p)({
            ...borderProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Tr.propTypes = {
    isActive: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_4__/* .utilityPropTypes */ .pQ,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingPropTypes */ .Xj
};
/* harmony default export */ __webpack_exports__["Z"] = (Tr);


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Table_Table; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Table.js





const Table = (param)=>{
    let { className ="" , isStriped =false , isBottomBorderedStriped =false , isBottomBordered =false , isBordered =false , isBorderedWrapper =false , children , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
        className: (0,classes/* classes */.S)("table", isBottomBordered && "table-bottom-bordered", isBottomBorderedStriped && "table-bottom-bordered-striped", isBordered && "table-bordered", isBorderedWrapper && "table-bordered-wrapper", isStriped && "table-striped", ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Table.propTypes = {
    className: prop_types.string,
    isBottomBordered: prop_types.bool,
    isBordered: prop_types.bool,
    isBorderedWrapper: prop_types.bool,
    isStriped: prop_types.bool,
    isBottomBorderedStriped: prop_types.bool,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Table_Table = (Table);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Table/index.js



/***/ }),

/***/ 97849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Item; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Grid.js






const TabCol = (param)=>/*#__PURE__*/ {
    let { className , cell ="" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        className: (0,classes/* classes */.S)(cell, ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        role: "presentation"
    });
};
TabCol.propTypes = {
    cell: prop_types.string,
    ...Grid/* Col.propTypes */.JX.propTypes
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Title.js









const TabTitle = (param)=>{
    let { Tag =Link/* default */.Z , tabType =1 , tabID ="" , isAnchor =false , active =false , className , px =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    const ResultTag = active ? "span" : Tag;
    const anchor = isAnchor ? {
        id: "".concat(tabID, "-tab"),
        href: "#".concat(tabID)
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultTag, {
        "data-toggle": "tab",
        role: "tab",
        "aria-controls": tabID,
        "aria-selected": active,
        className: (0,classes/* classes */.S)("tabs-v".concat(tabType, "__item"), active && "tabs-v".concat(tabType, "__item--active"), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)((0,pureProps/* deepMergeProps */.p)(px ? {
            md: {
                px: 10
            }
        } : {}, (0,pureProps/* default */.Z)(spacing))), className),
        ...anchor,
        ...props
    });
};
TabTitle.propTypes = {
    Tag: prop_types.elementType,
    tabID: prop_types.string,
    tabType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    isAnchor: prop_types.bool,
    active: prop_types.bool,
    px: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string
};
/* harmony default export */ var Title = (TabTitle);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Item.js





const TabItem = (param)=>{
    let { tabType =1 , active =false , tabClassName , cell ="medium-shrink" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabCol, {
        className: tabClassName,
        cell: cell,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
            tabType: tabType,
            active: active,
            ...props
        })
    });
};
TabItem.propTypes = {
    cell: prop_types.string,
    tabType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    tabClassName: prop_types.string,
    active: prop_types.bool,
    ...Title.propTypes
};
/* harmony default export */ var Item = (TabItem);


/***/ }),

/***/ 77739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Tabs_Tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/Tabs.js






const Tabs = (param)=>{
    let { tabsID ="" , tabsType =1 , isBorderBottom =true , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        id: tabsID,
        className: (0,classes/* classes */.S)("tabs-v".concat(tabsType), isBorderBottom && "tabs-v".concat(tabsType, "--border-bottom"), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        role: "tablist",
        ...props,
        children: children
    });
};
Tabs.propTypes = {
    isBorderBottom: prop_types.bool,
    tabsType: (0,prop_types.oneOf)([
        1,
        2
    ]),
    tabsID: prop_types.string,
    className: prop_types.string,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Tabs_Tabs = (Tabs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/index.js



/***/ }),

/***/ 94394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);




const WistiaVideoEmbed = (param)=>{
    let { id , className =""  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(()=>{
        const script = document.createElement("script");
        script.src = "https://fast.wistia.com/embed/medias/".concat(id, ".jsonp");
        script.async = true;
        document.body.appendChild(script);
        return ()=>{
            script.remove();
        };
    }, [
        id
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("wistia_embed", "wistia_async_".concat(id), "wistia-block-detail__embed", "videoFoam=true", className)
    });
};
WistiaVideoEmbed.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (WistiaVideoEmbed);


/***/ }),

/***/ 6292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WistiaVideo_WistiaVideo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/WistiaVideo.js



const WistiaVideo = (param)=>{
    let { children  } = param;
    (0,react.useEffect)(()=>{
        if (!document.getElementById("wistia_script")) {
            const wistiaScript = document.createElement("script");
            wistiaScript.id = "wistia_script";
            wistiaScript.type = "text/javascript";
            wistiaScript.src = "https://fast.wistia.com/assets/external/E-v1.js";
            wistiaScript.async = true;
            document.body.appendChild(wistiaScript);
            /* eslint no-underscore-dangle: ["error", { "allow": ["_wq"] }] */ window._wq = window._wq || [];
            // eslint-disable-next-line no-undef
            _wq.push({
                id: "_all",
                onReady (video) {
                    video.bind("play", ()=>{
                        // eslint-disable-next-line no-undef
                        const allVideos = Wistia.api.all();
                        allVideos.forEach((v)=>{
                            if (v.uuid !== video.uuid) {
                                v.pause();
                            }
                        });
                    });
                }
            });
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "wistia-video-container",
        children: children
    });
};
WistiaVideo.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var WistiaVideo_WistiaVideo = (WistiaVideo);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 27276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q0": function() { return /* reexport */ BlockQuote_BlockQuote; },
  "_w": function() { return /* reexport */ Thumb; },
  "ZP": function() { return /* reexport */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/BlockQuote.js




const BlockQuote = (param)=>{
    let { author , jobTitle ="" , institution , active =false , isBorderNone =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classes/* classes */.S)("bq__item", active && "bq__item--active", isBorderNone && "bq__item--border-none", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-message",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-author",
                children: author
            }),
            jobTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-job-title",
                children: jobTitle
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bq__item-institution",
                children: institution
            })
        ]
    });
};
BlockQuote.propTypes = {
    author: prop_types.string.isRequired,
    jobTitle: prop_types.string,
    institution: prop_types.string.isRequired,
    active: prop_types.bool,
    isBorderNone: prop_types.bool,
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var BlockQuote_BlockQuote = (BlockQuote);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/Thumb.js






const BlockQuoteThumb = (param)=>{
    let { className ="" , src , alt ="" , active =false , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        ...props,
        md: "auto",
        className: (0,classes/* classes */.S)("bq__item-thumb", active && "bq__item-thumb--active", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                align: {
                    items: "center"
                }
            },
            className: "bq__item-thumb-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: src,
                    alt: alt
                })
            })
        })
    });
};
BlockQuoteThumb.propTypes = {
    src: prop_types.string.isRequired,
    alt: prop_types.string,
    active: prop_types.bool,
    className: prop_types.string
};
/* harmony default export */ var Thumb = (BlockQuoteThumb);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/BlockQuote/Slider.js






const Head = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        id: "BlockQuoteHead",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            children: children
        })
    });
};
Head.propTypes = {
    children: prop_types.node.isRequired
};
const Thumbs = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        mx: true,
        id: "BlockQuoteThumbs",
        spacing: {
            mb: 15
        },
        children: children
    });
};
Thumbs.propTypes = {
    children: prop_types.node.isRequired
};
const Footer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            children: children
        })
    });
};
Footer.propTypes = {
    children: prop_types.node.isRequired
};
const BlockQuoteSlider = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        spacing: {
            pb: 20
        },
        className: "bq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
            lg: 10,
            center: true,
            children: children
        })
    });
};
BlockQuoteSlider.propTypes = {
    children: prop_types.node.isRequired
};
BlockQuoteSlider.Head = Head;
BlockQuoteSlider.Thumbs = Thumbs;
BlockQuoteSlider.Footer = Footer;
/* harmony default export */ var Slider = (BlockQuoteSlider);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/BlockQuote/index.js
// TODO: import to this file is deprecated!






/***/ }),

/***/ 49755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d6": function() { return /* binding */ VectorPageContactUs; },
  "tK": function() { return /* binding */ VectorPageContainer; },
  "e7": function() { return /* binding */ VectorPageImageWrapper; },
  "uF": function() { return /* binding */ VectorPageListItem; },
  "Fv": function() { return /* binding */ VectorPageListWrapper; },
  "OI": function() { return /* binding */ VectorPageParagraph; },
  "Kf": function() { return /* binding */ VectorPageParagraphWrapper; },
  "BZ": function() { return /* binding */ VectorPageSubTitle; },
  "S$": function() { return /* binding */ VectorPageTabWrapper; },
  "ys": function() { return /* binding */ VectorPageTable; },
  "Ci": function() { return /* binding */ VectorPageTableItem; },
  "yW": function() { return /* binding */ VectorPageTableItemWrapper; },
  "pe": function() { return /* binding */ VectorPageTitle; },
  "fU": function() { return /* binding */ VectorPageTryButton; },
  "lL": function() { return /* binding */ VectorPageTryButtonWrapper; },
  "Pn": function() { return /* binding */ VectorPageVideoContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Thead.js
var Thead = __webpack_require__(40662);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Tbody.js
var Tbody = __webpack_require__(72483);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Tr.js
var Tr = __webpack_require__(455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Th.js
var Th = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/Td.js
var Td = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/ResponsiveWrapper.js
var ResponsiveWrapper = __webpack_require__(41848);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Table/index.js + 1 modules
var Table = __webpack_require__(72379);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/Table/index.js
// TODO: import to this file is deprecated!









// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/VectorNTI/index.js








const VectorPageContainer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        spacing: {
            my: 20
        },
        children: children
    });
};
VectorPageContainer.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 7,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h2",
                sx: {
                    fontSize: "xl",
                    textAlign: "center"
                },
                children: children
            })
        })
    });
};
VectorPageTitle.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageSubTitle = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 6,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "l"
                },
                children: children
            })
        })
    });
};
VectorPageSubTitle.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageListWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 6,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: "mt-10",
                children: children
            })
        })
    });
};
VectorPageListWrapper.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageListItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "mt-5",
        children: children
    });
};
VectorPageListItem.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageTryButtonWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 6,
            spacing: {
                mt: 10
            },
            sx: {
                textAlign: "center"
            },
            children: children
        })
    });
};
VectorPageTryButtonWrapper.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageTryButton = (param)=>{
    let { href ="/try-snapgene/" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
        href: href,
        size: "s",
        ...props,
        children: children
    });
};
VectorPageTryButton.propTypes = {
    href: prop_types.string,
    children: prop_types.node.isRequired
};
const VectorPageTable = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 6,
            spacing: {
                mt: 10
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                isBottomBorderedStriped: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tbody/* default */.Z, {
                    children: children
                })
            })
        })
    });
};
VectorPageTable.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageTableItemWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tr/* default */.Z, {
        children: children
    });
};
VectorPageTableItemWrapper.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageTableItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td/* default */.Z, {
        spacing: {
            py: 2,
            px: 4
        },
        children: children
    });
};
VectorPageTableItem.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageParagraphWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 7,
            spacing: {
                mt: 10
            },
            children: children
        })
    });
};
VectorPageParagraphWrapper.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageParagraph = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        ...props,
        children: children
    });
};
VectorPageParagraph.propTypes = {
    ...Paragraph/* default.propTypes */.Z.propTypes,
    children: prop_types.node.isRequired
};
const VectorPageTabWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 10,
            spacing: {
                mt: 10
            },
            children: children
        })
    });
};
VectorPageTabWrapper.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageImageWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 10,
            lg: 10,
            spacing: {
                my: 15
            },
            children: children
        })
    });
};
VectorPageImageWrapper.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageVideoContainer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            md: 8,
            lg: 6,
            spacing: {
                mt: 10
            },
            sx: {
                textAlign: "center"
            },
            children: children
        })
    });
};
VectorPageVideoContainer.propTypes = {
    children: prop_types.node.isRequired
};
const VectorPageContactUs = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        spacing: {
            mb: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                justify: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                sm: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                    sx: {
                        textAlign: "center"
                    },
                    children: children
                })
            })
        })
    });
};
VectorPageContactUs.propTypes = {
    children: prop_types.node.isRequired
};


/***/ }),

/***/ 20590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);





const LightBoxItem = (param)=>{
    let { preview , full , openSlide  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        "data-fslightbox": true,
        href: full,
        onClick: (e)=>openSlide(e, full),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: preview,
            className: "width-100"
        })
    });
};
LightBoxItem.propTypes = {
    preview: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    full: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    openSlide: prop_types__WEBPACK_IMPORTED_MODULE_4__.func.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LightBoxItem);


/***/ }),

/***/ 71572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _WistiaVideo_Embed__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _WistiaVideo_Embed__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94394);



/***/ }),

/***/ 52198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _WistiaVideo__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _WistiaVideo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6292);



/***/ }),

/***/ 53381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export context */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Tabs_Item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97849);




const context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    active: null,
    setActive: ()=>{}
});
const SmartTabs = (param)=>{
    let { initialActiveTab , children  } = param;
    const [active, setActive] = react__WEBPACK_IMPORTED_MODULE_1__.useState(initialActiveTab);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Provider, {
        value: {
            active,
            setActive
        },
        children: children
    });
};
SmartTabs.propTypes = {
    initialActiveTab: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
const SmartTab = (param)=>{
    let { id , Component =_Tabs_Item__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , ...props } = param;
    const { active , setActive  } = react__WEBPACK_IMPORTED_MODULE_1__.useContext(context);
    const openTab = react__WEBPACK_IMPORTED_MODULE_1__.useCallback((event)=>{
        event.preventDefault();
        setActive(id);
    }, [
        id,
        setActive
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        active: id === active,
        onClick: openTab,
        ...props,
        id: id
    });
};
SmartTab.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.elementType
    ]),
    cell: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
const SmartTabBody = (param)=>/*#__PURE__*/ {
    let { id , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Consumer, {
        children: (param)=>{
            let { active  } = param;
            return active === id && children;
        }
    });
};
SmartTabBody.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
const MountedTabBody = (param)=>/*#__PURE__*/ {
    let { id , children , Component  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context.Consumer, {
        children: (param)=>/*#__PURE__*/ {
            let { active  } = param;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                style: {
                    display: active === id ? "block" : "none"
                },
                children: children
            });
        }
    });
};
MountedTabBody.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node,
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_3__.elementType
    ]).isRequired
};
SmartTabBody.Mounted = MountedTabBody;
SmartTabs.Tab = SmartTab;
SmartTabs.TabBody = SmartTabBody;
/* harmony default export */ __webpack_exports__["Z"] = (SmartTabs);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);